import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import ItemsList from '../components/ItemsList';
import { routes } from '../constants';
import { selectPinnedContents, selectPinnedPagination, selectPinnedStatus } from '../reducers/pinned.selectors';
import { createNextPaginationRequest, createPaginationRequest, hasNext } from '../utils/pagination';
import { fetchPinnedContents as fetchPinnedContentsAction } from '../actions/pinned.actions';
import CollectionsAppLayout from '../components/AppLayout/Collections/CollectionsAppLayout';
import CollectionsTabs from '../components/AppLayout/Collections/CollectionsTabs';
import MasterLayout from '../components/AppLayout/MasterLayout';
import { selectUser } from '../reducers/user.selectors';
import useAction from '../utils/useAction';
import { useContext } from 'react';
import { NotificationContext } from '../state/NotificationContextProvider';
import { Alert } from '../components/NotificationAlert/NotificationAlert';

const PinnedItemListPage: React.FC = () => {
  const { t } = useTranslation();
  const user = useSelector(selectUser);
  const pinnedPagination = useSelector(selectPinnedPagination);
  const pinnedContents = useSelector(selectPinnedContents);
  const pinnedStatus = useSelector(selectPinnedStatus);
  const fetchPinnedContents = useAction(fetchPinnedContentsAction);
  const { showNotification } = useContext(NotificationContext);

  const paginationRequest = createPaginationRequest(pinnedPagination);
  const nextPaginationRequest = createNextPaginationRequest(pinnedPagination);

  useEffect(() => {
    if (user) {
      fetchPinnedContents(paginationRequest);
    }
  }, [user]);

  const [activeId, setActiveId] = useState('');

  const handleShowNotification = (alert: Alert) => {
    showNotification(alert);
  };

  const mainBody = <ItemsList
    isLoading={pinnedStatus === 'loading'}
    hasNext={hasNext(pinnedPagination)}
    total={pinnedStatus === 'loading' ? -1 : pinnedContents.length}
    loadNext={() => {
      return fetchPinnedContents(nextPaginationRequest);
    }}
    activeId={activeId}
    items={pinnedContents}
    linkRoot={[routes.pinned.root]}
    setActiveId={setActiveId}
    onShowNotification={handleShowNotification}
  />;

  return (
    <MasterLayout isNewMerklistePage={true}>
      <CollectionsAppLayout
        title={t('Saved')}
        tabs={<CollectionsTabs
          activeTab={routes.pinned.root}
          isNewDesignEnabled={true}
        />}
        body={mainBody}
        backgroundClick={() => { setActiveId(''); }}
        isSearchPageContainer={true}
      />
    </MasterLayout>
  );
};

export default PinnedItemListPage;
